import { render, staticRenderFns } from "./choosePaymentMethod_dana.vue?vue&type=template&id=9db10bbe&"
import script from "./choosePaymentMethod_dana.vue?vue&type=script&lang=js&"
export * from "./choosePaymentMethod_dana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports